import { useGetUser } from "atom/user"
import { jsonAxios } from "components/axios"
import CustomButton from "components/common/CustomButton"
import CustomInput from "components/common/CustomInput"
import { SetStateAction, useEffect, useState } from "react"
import { toast } from "react-toastify"

interface INewSecond {
    blNo: string
    setBlNo: React.Dispatch<SetStateAction<string>>
    setIsOpen: React.Dispatch<SetStateAction<boolean>>
}

const BlSearch = ({ blNo, setBlNo, setIsOpen }: INewSecond) => {
    const [isCorrect, setIsCorrect] = useState<boolean>(true);
    const user = useGetUser();

    useEffect(() => {
        !isCorrect && setIsCorrect(true)
    }, [blNo])

    const getBlNo = () => {
        if (!user.id) {
            return toast.error('해당 기능을 이용하기 위해서 로그인을 해주세요.')
        }
        const reqData = {
            blNo: blNo
        }
        jsonAxios.post('search/bl', reqData).then(res => {
            console.log(res.data)
            if (res.data.data) {
                setTimeout(() => {
                    setIsOpen(true)
                }, 400)
            }
            else {
                setIsCorrect(false)
            }
        })
    }

    return (
        <div className="p-10 pt-0 w-full">
            <div className="flex flex-col gap-3 mt-6">
                <p className='tablet:mb-1 mobile:text-lg text-2xl'>BL 번호</p>
                <CustomInput
                    type="text"
                    className="bg-white !border-[#9D9EB7]"
                    placeholder="BL 번호를 입력해주세요"
                    value={blNo ?? ''}
                    onChange={(e) => {
                        setBlNo(e.target.value)
                    }}
                />
                <div className="h-12 text-red">
                    {
                        !isCorrect &&
                        <p>
                            입력하신 BL 번호는 펄스온쉽에 등록된 BL 번호가 아닙니다. <br className="tablet:hidden block" />
                            확인 후 다시 조회해주세요.
                        </p>
                    }
                </div>
            </div>
            <CustomButton
                className="bg-primary w-full"
                title="조회하기"
                disabled={blNo.length === 0}
                onClick={getBlNo}
            />
        </div>
    )
}

export default BlSearch